import React, { useEffect, useState } from 'react';
import { ChallengeModuleLoader } from '../session/ChallengeModuleLoader';
import USBModal, {
    ModalBody,
} from '@usb-shield/react-modal';
import './CIAMAuthModal.css';

interface Props {
    showModal: boolean;
    onModalClose: () => void;
    onAuthSuccess: (data: any) => void;
    onAuthFailure: (data: any) => void;
}

const CIAMAuthModal = (props: Props) => {

    const [modalIsOpen, setModalIsOpen] = useState(props.showModal);

    useEffect(() => {
        setModalIsOpen(props.showModal);
    }, [props.showModal]);

    const onModalClose = () => {
        props.onModalClose();
    }

    return (
        <>
            <div id="challengewidgetModel">
                <USBModal
                    id="modal-basic"
                    isOpen={modalIsOpen}
                    handleClose={() => onModalClose()}
                >
                    <ModalBody>
                        <div className="challengeModalinnerContainer">
                            <ChallengeModuleLoader
                                onAuthSuccess={props.onAuthSuccess}
                                onAuthFailure={props.onAuthFailure}
                            />
                        </div>
                    </ModalBody>
                </USBModal>

            </div>
        </>
    );
};

export default CIAMAuthModal;
